(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@innovyze/lib-am-common/Reducers"), require("@reduxjs/toolkit"), require("redux"));
	else if(typeof define === 'function' && define.amd)
		define(["@innovyze/lib-am-common/Reducers", "@Reduxjs/Toolkit", "Redux"], factory);
	else if(typeof exports === 'object')
		exports["app-MODULE-NAME"] = factory(require("@innovyze/lib-am-common/Reducers"), require("@reduxjs/toolkit"), require("redux"));
	else
		root["app-MODULE-NAME"] = factory(root["@innovyze/lib-am-common/Reducers"], root["@Reduxjs/Toolkit"], root["Redux"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Reducers__, __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__, __WEBPACK_EXTERNAL_MODULE_redux__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./actions/CoF.actions.ts":
/*!********************************!*\
  !*** ./actions/CoF.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setCoFIsChanged = exports.deleteCoFCategory = exports.saveCoFRejected = exports.saveCoFResolved = exports.saveCoF = exports.setCoFComponents = exports.setCoFComponent = exports.addCoFComponent = exports.getCustomTableFieldsRejected = exports.getCustomTableFieldsResolved = exports.getCustomTableFields = exports.getProximityAttributeFieldsRejected = exports.getProximityAttributeFieldsResolved = exports.getProximityAttributeFields = exports.getCoFFieldsRejected = exports.getCoFFieldsResolved = exports.getCoFFields = exports.setCoFConfig = exports.addCoFConfig = exports.getCoFComponentsRejected = exports.getCoFComponentsResolved = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getCoFComponentsResolved = (0, toolkit_1.createAction)('CoF/getCoFComponentsResolved');
exports.getCoFComponentsRejected = (0, toolkit_1.createAction)('CoF/getCoFComponentsRejected');
exports.addCoFConfig = (0, toolkit_1.createAction)('CoF/addCoFConfig');
exports.setCoFConfig = (0, toolkit_1.createAction)('CoF/setCoFConfig');
exports.getCoFFields = (0, toolkit_1.createAction)('CoF/getCoFFields');
exports.getCoFFieldsResolved = (0, toolkit_1.createAction)('CoF/getCoFFieldsResolved');
exports.getCoFFieldsRejected = (0, toolkit_1.createAction)('CoF/getCoFFieldsRejected');
exports.getProximityAttributeFields = (0, toolkit_1.createAction)('ProximityAttribute/getProximityAttributeFields');
exports.getProximityAttributeFieldsResolved = (0, toolkit_1.createAction)('ProximityAttribute/getProximityAttributeFieldsResolved');
exports.getProximityAttributeFieldsRejected = (0, toolkit_1.createAction)('ProximityAttribute/getProximityAttributeFieldsRejected');
exports.getCustomTableFields = (0, toolkit_1.createAction)('CustomTable/getCustomTableFields');
exports.getCustomTableFieldsResolved = (0, toolkit_1.createAction)('CustomTable/getCustomTableFieldsResolved');
exports.getCustomTableFieldsRejected = (0, toolkit_1.createAction)('CustomTable/getCustomTableFieldsRejected');
exports.addCoFComponent = (0, toolkit_1.createAction)('CoF/addCoFComponent');
exports.setCoFComponent = (0, toolkit_1.createAction)('CoF/setCoFComponent');
exports.setCoFComponents = (0, toolkit_1.createAction)('CoF/setCoFComponents');
exports.saveCoF = (0, toolkit_1.createAction)('CoF/saveCoF');
exports.saveCoFResolved = (0, toolkit_1.createAction)('CoF/saveCoFResolved');
exports.saveCoFRejected = (0, toolkit_1.createAction)('CoF/saveCoFRejected');
exports.deleteCoFCategory = (0, toolkit_1.createAction)('CoF/deleteCoFCategory');
exports.setCoFIsChanged = (0, toolkit_1.createAction)('CoF/setCoFIsChanged');


/***/ }),

/***/ "./actions/LoF.actions.ts":
/*!********************************!*\
  !*** ./actions/LoF.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setLofIsChanged = exports.deleteCategory = exports.saveLoFRejected = exports.saveLoFResolved = exports.saveLoF = exports.setLoFComponents = exports.setLoFComponent = exports.addLoFComponent = exports.getLoFFieldsRejected = exports.getLoFFieldsResolved = exports.getLoFFields = exports.getLoFInspectionFieldsRejected = exports.getLoFInspectionFieldsResolved = exports.getLoFInspectionFields = exports.setLoFConfig = exports.addLoFConfig = exports.getLoFConfigRejected = exports.getLoFConfigResolved = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getLoFConfigResolved = (0, toolkit_1.createAction)('LoF/getLoFConfigResolved');
exports.getLoFConfigRejected = (0, toolkit_1.createAction)('LoF/getLoFConfigRejected');
exports.addLoFConfig = (0, toolkit_1.createAction)('LoF/addLoFConfig');
exports.setLoFConfig = (0, toolkit_1.createAction)('LoF/setLoFConfig');
exports.getLoFInspectionFields = (0, toolkit_1.createAction)('LoF/getLoFInspectionFields');
exports.getLoFInspectionFieldsResolved = (0, toolkit_1.createAction)('LoF/getLoFInspectionFieldsResolved');
exports.getLoFInspectionFieldsRejected = (0, toolkit_1.createAction)('LoF/getLoFInspectionFieldsRejected');
exports.getLoFFields = (0, toolkit_1.createAction)('LoF/getLoFFields');
exports.getLoFFieldsResolved = (0, toolkit_1.createAction)('LoF/getLoFFieldsResolved');
exports.getLoFFieldsRejected = (0, toolkit_1.createAction)('LoF/getLoFFieldsRejected');
exports.addLoFComponent = (0, toolkit_1.createAction)('LoF/addLoFComponent');
exports.setLoFComponent = (0, toolkit_1.createAction)('LoF/setLoFComponent');
exports.setLoFComponents = (0, toolkit_1.createAction)('LoF/setLoFComponents');
exports.saveLoF = (0, toolkit_1.createAction)('LoF/saveLoF');
exports.saveLoFResolved = (0, toolkit_1.createAction)('LoF/saveLoFResolved');
exports.saveLoFRejected = (0, toolkit_1.createAction)('LoF/saveLoFRejected');
exports.deleteCategory = (0, toolkit_1.createAction)('LoF/deleteCategory');
exports.setLofIsChanged = (0, toolkit_1.createAction)('Lof/setLofIsChanged');


/***/ }),

/***/ "./actions/Risk.actions.ts":
/*!*********************************!*\
  !*** ./actions/Risk.actions.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.changeFilterSelect = exports.getTaskDataResolved = exports.getTaskData = exports.getSimulationDataResolved = exports.getSimulationData = exports.getLogRejected = exports.getLogResolved = exports.getLog = exports.setRiskCalcStatus = exports.setSaveRun = exports.setTab = exports.setRiskDetailsIsBusy = exports.currentRow = exports.clearSelected = exports.removeSelected = exports.addSelected = exports.setSelected = exports.changeSort = exports.clearScanId = exports.setSearchStartSaga = exports.setSearchStart = exports.changeSearch = exports.changePage = exports.changeSlice = exports.clearRiskScanId = exports.changePagination = exports.getRiskDetailsRejected = exports.getRiskDetailsResolved = exports.getRiskDetailsWSReseived = exports.reloadRiskDetails = exports.getRiskDetailsDefaulted = exports.resetRiskResolved = exports.resetRiskRejected = exports.resetRisk = exports.runRiskResolved = exports.runRiskRejected = exports.runRisk = exports.getRiskDetails = exports.saveRiskConfigAction = exports.renameRiskConfigAction = exports.setRiskConfigNameError = exports.setRiskConfigIsCreating = exports.duplicateRiskConfig = exports.changeRiskConfigPublishState = exports.createRiskConfig = exports.clearRiskConfig = exports.getRiskConfigRejected = exports.getRiskConfigResolved = exports.getRiskConfig = exports.paginationDefault = void 0;
exports.setOverallRisk = exports.clearMatrixUpdate = exports.setOnlyGradesUpdated = exports.setEditedCellsList = exports.setRefreshMatrixGrid = exports.setRiskMatrixAfterPreview = exports.setMatrixPreviewStatus = exports.setIsPreviewOnLoad = exports.setIsPreviewLoading = exports.setCancellPreview = exports.setEnablePreview = exports.getRiskMatrixPreview = exports.cancelRiskMatrixPreview = exports.initRiskMatrixPreview = exports.setRiskType = exports.setUpdatedScores = exports.setDidMatrixUpdate = exports.setUpdatedRanges = exports.renameRiskCount = exports.getRiskCountResolved = exports.getRiskCountScoreMatrix = exports.getRiskCountTask = exports.getRiskCountCustomTable = exports.getRiskCountProximityAttribute = exports.getRiskCountProximity = exports.getRiskCountObservation = exports.getRiskCountAttribute = exports.getRiskCountInspection = exports.setRiskCountIsLoading = exports.setRiskIsDeleting = exports.deleteRisk = exports.setRiskIsSaving = exports.setRefreshList = exports.setRunCompleteReload = exports.setRiskSetupDirty = exports.translate = exports.updateColumnFilterSelectOptions = exports.changeFiltersSelect = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
var Reducers_1 = __webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var paginationDefault = function () { return (__assign(__assign({}, Reducers_1.paginationInitialState), { sortKey: 'CURRENT_RISK', sortDescending: true })); };
exports.paginationDefault = paginationDefault;
exports.getRiskConfig = (0, toolkit_1.createAction)('Risk/getRiskConfig');
exports.getRiskConfigResolved = (0, toolkit_1.createAction)('Risk/getRiskConfigResolved');
exports.getRiskConfigRejected = (0, toolkit_1.createAction)('Risk/getRiskConfigRejected');
exports.clearRiskConfig = (0, toolkit_1.createAction)('Risk/clearRiskConfig');
exports.createRiskConfig = (0, toolkit_1.createAction)('Risk/createRiskConfig');
exports.changeRiskConfigPublishState = (0, toolkit_1.createAction)('Risk/changeRiskConfigPublishState');
exports.duplicateRiskConfig = (0, toolkit_1.createAction)('Risk/duplicateRiskConfig');
exports.setRiskConfigIsCreating = (0, toolkit_1.createAction)('riskSetup/setRiskConfigIsCreating');
exports.setRiskConfigNameError = (0, toolkit_1.createAction)('riskSetup/setRiskConfigNameError');
exports.renameRiskConfigAction = (0, toolkit_1.createAction)('Risk/renameRiskConfig');
exports.saveRiskConfigAction = (0, toolkit_1.createAction)('Risk/saveRiskConfig');
exports.getRiskDetails = (0, toolkit_1.createAction)('risk/getRiskDetails');
exports.runRisk = (0, toolkit_1.createAction)('risk/runRisk');
exports.runRiskRejected = (0, toolkit_1.createAction)('risk/runRiskRejected');
exports.runRiskResolved = (0, toolkit_1.createAction)('risk/runRiskResolved');
exports.resetRisk = (0, toolkit_1.createAction)('risk/resetRisk');
exports.resetRiskRejected = (0, toolkit_1.createAction)('risk/resetRiskRejected');
exports.resetRiskResolved = (0, toolkit_1.createAction)('risk/resetRiskResolved');
var getRiskDetailsDefaulted = function () {
    return (0, exports.getRiskDetails)((0, exports.paginationDefault)());
};
exports.getRiskDetailsDefaulted = getRiskDetailsDefaulted;
exports.reloadRiskDetails = (0, toolkit_1.createAction)('risk/reloadRiskDetails');
exports.getRiskDetailsWSReseived = (0, toolkit_1.createAction)('riskdetails/getRiskDetails/WSReseived');
exports.getRiskDetailsResolved = (0, toolkit_1.createAction)('riskdetails/getRiskDetails/resolved');
exports.getRiskDetailsRejected = (0, toolkit_1.createAction)('riskdetails/getRiskDetails/rejected');
exports.changePagination = (0, toolkit_1.createAction)('riskdetails/paginationModel');
exports.clearRiskScanId = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskdetails/clearRiskScanId'));
exports.changeSlice = (0, toolkit_1.createAction)('riskdetails/slice');
exports.changePage = (0, toolkit_1.createAction)('riskdetails/page');
exports.changeSearch = (0, toolkit_1.createAction)('riskdetails/changeSearch');
exports.setSearchStart = (0, toolkit_1.createAction)('riskdetails/setSearchStart');
exports.setSearchStartSaga = (0, toolkit_1.createAction)('riskdetails/setSearchStartSaga');
exports.clearScanId = (0, toolkit_1.createAction)('riskdetails/clearScanId');
exports.changeSort = (0, toolkit_1.createAction)('riskdetails/sort');
exports.setSelected = (0, toolkit_1.createAction)('riskdetails/selected/set');
exports.addSelected = (0, toolkit_1.createAction)('riskdetails/selected/add');
exports.removeSelected = (0, toolkit_1.createAction)('riskdetails/selected/remove');
exports.clearSelected = (0, toolkit_1.createAction)('riskdetails/selected/clear');
exports.currentRow = (0, toolkit_1.createAction)('riskdetails/current/row');
exports.setRiskDetailsIsBusy = (0, toolkit_1.createAction)('riskdetails/isBusy');
exports.setTab = (0, toolkit_1.createAction)('Risk/setTab');
exports.setSaveRun = (0, toolkit_1.createAction)('Risk/setSaveRun');
exports.setRiskCalcStatus = (0, toolkit_1.createAction)('Risk/setRiskCalcStatus');
exports.getLog = (0, toolkit_1.createAction)('Log/getLog');
exports.getLogResolved = (0, toolkit_1.createAction)('Log/getLogResolved');
exports.getLogRejected = (0, toolkit_1.createAction)('Log/getLogRejected');
exports.getSimulationData = (0, toolkit_1.createAction)('Risk/getSimulationData');
exports.getSimulationDataResolved = (0, toolkit_1.createAction)('Risk/getSimulationDataResolved');
exports.getTaskData = (0, toolkit_1.createAction)('Risk/getTaskData');
exports.getTaskDataResolved = (0, toolkit_1.createAction)('Risk/getTaskDataResolved');
exports.changeFilterSelect = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/filterSelect'));
exports.changeFiltersSelect = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/filtersSelect'));
exports.updateColumnFilterSelectOptions = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/filterSelect/column/options'));
exports.translate = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/translate'));
exports.setRiskSetupDirty = (0, toolkit_1.createAction)('riskSetup/setRiskSetupDirty');
exports.setRunCompleteReload = (0, toolkit_1.createAction)('Risk/riskCompleteReload');
exports.setRefreshList = (0, toolkit_1.createAction)('Risk/setRefreshList');
exports.setRiskIsSaving = (0, toolkit_1.createAction)('riskSetup/setRiskIsSaving');
exports.deleteRisk = (0, toolkit_1.createAction)('rehab/deleteRisk');
exports.setRiskIsDeleting = (0, toolkit_1.createAction)('risk/setRiskIsDeleting');
exports.setRiskCountIsLoading = (0, toolkit_1.createAction)('Risk/setRiskCountIsLoading');
exports.getRiskCountInspection = (0, toolkit_1.createAction)('Risk/getRiskCountInspection');
exports.getRiskCountAttribute = (0, toolkit_1.createAction)('Risk/getRiskCountAttribute');
exports.getRiskCountObservation = (0, toolkit_1.createAction)('Risk/getRiskCountObservation');
exports.getRiskCountProximity = (0, toolkit_1.createAction)('Risk/getRiskCountProximity');
exports.getRiskCountProximityAttribute = (0, toolkit_1.createAction)('Risk/getRiskCountProximityAttribute');
exports.getRiskCountCustomTable = (0, toolkit_1.createAction)('Risk/getRiskCountCustomTable');
exports.getRiskCountTask = (0, toolkit_1.createAction)('Risk/getRiskCountTask');
exports.getRiskCountScoreMatrix = (0, toolkit_1.createAction)('Risk/getRiskCountScoreMatrix');
exports.getRiskCountResolved = (0, toolkit_1.createAction)('Risk/getRiskCountResolved');
exports.renameRiskCount = (0, toolkit_1.createAction)('Risk/renameRiskCount');
//=== risk Matrix actions =====
exports.setUpdatedRanges = (0, toolkit_1.createAction)('Risk/setUpdatedRanges');
exports.setDidMatrixUpdate = (0, toolkit_1.createAction)('Risk/setDidMatrixUpdate');
exports.setUpdatedScores = (0, toolkit_1.createAction)('Risk/setUpdatedScores');
exports.setRiskType = (0, toolkit_1.createAction)('Risk/setRiskType'); //switch between linear and matrix
exports.initRiskMatrixPreview = (0, toolkit_1.createAction)('Risk/initRiskMatrixPreview');
exports.cancelRiskMatrixPreview = (0, toolkit_1.createAction)('Risk/cancelRiskMatrixPreview');
exports.getRiskMatrixPreview = (0, toolkit_1.createAction)('Risk/getRiskMatrixPreview');
exports.setEnablePreview = (0, toolkit_1.createAction)('Risk/setEnablePreview');
exports.setCancellPreview = (0, toolkit_1.createAction)('Risk/setCancellPreview');
exports.setIsPreviewLoading = (0, toolkit_1.createAction)('Risk/setIsPreviewLoading');
exports.setIsPreviewOnLoad = (0, toolkit_1.createAction)('Risk/setIsPreviewOnLoad');
exports.setMatrixPreviewStatus = (0, toolkit_1.createAction)('Risk/setmatrixPreviewStatus');
exports.setRiskMatrixAfterPreview = (0, toolkit_1.createAction)('Risk/setRiskMatrixAfterPreview');
exports.setRefreshMatrixGrid = (0, toolkit_1.createAction)('Risk/setRefreshMatrixGrid');
exports.setEditedCellsList = (0, toolkit_1.createAction)('Risk/updateEditedCellsList');
exports.setOnlyGradesUpdated = (0, toolkit_1.createAction)('Risk/setOnlyGradesUpdated');
exports.clearMatrixUpdate = (0, toolkit_1.createAction)('Risk/clearMatrixUpdate');
exports.setOverallRisk = (0, toolkit_1.createAction)('Risk/setOverallRisk');
//===================


/***/ }),

/***/ "./actions/asset.actions.ts":
/*!**********************************!*\
  !*** ./actions/asset.actions.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSpatialLayerListRejected = exports.getSpatialLayerListResolved = exports.getSpatialLayerList = exports.getAssetFilterListResolved = exports.getAssetFilterListRejected = exports.getAssetFilterList = exports.clearAssetFields = exports.getAssetFieldsRejected = exports.getAssetFieldsResolved = exports.getAssetFields = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetFields = (0, toolkit_1.createAction)('asset/getAssetFields');
exports.getAssetFieldsResolved = (0, toolkit_1.createAction)('asset/getAssetFieldsResolved');
exports.getAssetFieldsRejected = (0, toolkit_1.createAction)('asset/getAssetFieldsRejected');
exports.clearAssetFields = (0, toolkit_1.createAction)('asset/clearAssetFields');
exports.getAssetFilterList = (0, toolkit_1.createAction)('asset/getAssetFilterList');
exports.getAssetFilterListRejected = (0, toolkit_1.createAction)('asset/getAssetFilterListRejected');
exports.getAssetFilterListResolved = (0, toolkit_1.createAction)('asset/getAssetFilterListResolved');
exports.getSpatialLayerList = (0, toolkit_1.createAction)('Asset/getSpatialLayerList');
exports.getSpatialLayerListResolved = (0, toolkit_1.createAction)('Asset/getSpatialLayerListResolved');
exports.getSpatialLayerListRejected = (0, toolkit_1.createAction)('Asset/getSpatialLayerListRejected');


/***/ }),

/***/ "./actions/component.actions.ts":
/*!**************************************!*\
  !*** ./actions/component.actions.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getComponentMetadataRejected = exports.getComponentMetadataResolved = exports.getCoFComponentTaskMetadata = exports.getLoFComponentTaskMetadata = exports.getCoFComponentCustomTableMetadata = exports.getLoFComponentCustomTableMetadata = exports.getCoFComponentProximityAttrMetadata = exports.getLoFComponentProximityAttrMetadata = exports.getCoFComponentProximityMetadata = exports.getLoFComponentProximityMetadata = exports.getCoFComponentAssetMetadata = exports.getLoFComponentInspectionMetadata = exports.getLoFComponentAssetMetadata = exports.clearComponentMetadata = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.clearComponentMetadata = (0, toolkit_1.createAction)('Comp/clearComponentMetadata');
exports.getLoFComponentAssetMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentAssetMetadata');
exports.getLoFComponentInspectionMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentInpsectionMetadata');
exports.getCoFComponentAssetMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentAssetMetadata');
exports.getLoFComponentProximityMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentProximityMetadata');
exports.getCoFComponentProximityMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentProximityMetadata');
exports.getLoFComponentProximityAttrMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentProximityAttrMetadata');
exports.getCoFComponentProximityAttrMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentProximityAttrMetadata');
exports.getLoFComponentCustomTableMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentCustomTableMetadata');
exports.getCoFComponentCustomTableMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentCustomTableMetadata');
exports.getLoFComponentTaskMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentTaskMetadata');
exports.getCoFComponentTaskMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentTaskMetadata');
exports.getComponentMetadataResolved = (0, toolkit_1.createAction)('Comp/getComponentMetadataResolved');
exports.getComponentMetadataRejected = (0, toolkit_1.createAction)('Comp/getComponentMetadataRejected');


/***/ }),

/***/ "./actions/index.ts":
/*!**************************!*\
  !*** ./actions/index.ts ***!
  \**************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./LoF.actions */ "./actions/LoF.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./CoF.actions */ "./actions/CoF.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./Risk.actions */ "./actions/Risk.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./asset.actions */ "./actions/asset.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./component.actions */ "./actions/component.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./util.actions */ "./actions/util.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./map.actions */ "./actions/map.actions.ts"), exports);


/***/ }),

/***/ "./actions/map.actions.ts":
/*!********************************!*\
  !*** ./actions/map.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.changeSpatialProximity = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.changeSpatialProximity = (0, toolkit_1.createAction)('spatialProximity/changeDataSource');


/***/ }),

/***/ "./actions/util.actions.ts":
/*!*********************************!*\
  !*** ./actions/util.actions.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setDataGridState = exports.setRiskLastRun = exports.setRiskRunning = exports.setRiskStatus = exports.setRiskNullScore = exports.updateRiskValuesDataGrid = exports.updateRiskScoreDataGrid = exports.updateRiskMultiScoreDataGridRow = exports.setRiskMultiScoreDataGrid = exports.setRiskScoreDataGrid = exports.setRiskScoreTable = exports.setRiskUnitScores = exports.setRiskEditScores = exports.setRiskScores = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.setRiskScores = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskScores'));
exports.setRiskEditScores = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskEditScores'));
exports.setRiskUnitScores = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskUnitScores'));
exports.setRiskScoreTable = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskScoreTable'));
exports.setRiskScoreDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskScoreDataGrid'));
exports.setRiskMultiScoreDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskMultiScoreDataGrid'));
exports.updateRiskMultiScoreDataGridRow = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/updateRiskMultiScoreDataGridRow'));
exports.updateRiskScoreDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/updateRiskScoreDataGrid'));
exports.updateRiskValuesDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/updateRiskValuesDataGrid'));
exports.setRiskNullScore = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskNullScore'));
exports.setRiskStatus = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskStatus'));
exports.setRiskRunning = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskRunning'));
exports.setRiskLastRun = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskLastRun'));
exports.setDataGridState = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('dataGrid/state'));


/***/ }),

/***/ "./reducers/CoF.reducers.ts":
/*!**********************************!*\
  !*** ./reducers/CoF.reducers.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cofReducer = exports.reducer = exports.initState = void 0;
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var sort_1 = __webpack_require__(/*! @Utils/sort */ "./utils/sort.ts");
exports.initState = {
    componentFields: [],
    categories: [],
    isLoadingCategories: false,
    isLoadingFields: false,
    isChanged: false,
    isValid: true,
};
exports.reducer = (_a = {},
    _a[_Actions_1.getCoFComponentsResolved.toString()] = function (state, action) {
        var category = action.payload;
        return __assign(__assign({}, state), { categories: category, isLoadingCategories: false });
    },
    _a[_Actions_1.getCoFComponentsRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isLoadingFields: false })); },
    _a[_Actions_1.getCoFFields.toString()] = function (state) { return (__assign(__assign({}, state), { componentFields: [], isLoadingFields: true })); },
    _a[_Actions_1.getCoFFieldsResolved.toString()] = function (state, action) {
        var fields = action.payload;
        return __assign(__assign({}, state), { componentFields: (0, sort_1.sortFields)(fields), isLoadingFields: false });
    },
    _a[_Actions_1.getCoFFieldsRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isLoadingFields: false })); },
    _a[_Actions_1.addCoFConfig.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: __spreadArray(__spreadArray([], (state.categories || []), true), [action.payload], false), isChanged: true })); },
    _a[_Actions_1.setCoFConfig.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: action.payload, isChanged: true })); },
    _a[_Actions_1.addCoFComponent.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: state.categories.map(function (category) {
            return category.name === action.payload.categoryName
                ? __assign(__assign({}, category), { components: __spreadArray(__spreadArray([], category.components, true), [
                        action.payload.component,
                    ], false) }) : category;
        }), isChanged: true })); },
    _a[_Actions_1.setCoFComponent.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: state.categories.map(function (category) {
            return category.name === action.payload.categoryName
                ? __assign(__assign({}, category), { components: category.components.map(function (component) {
                        return component.name === action.payload.componentName
                            ? action.payload.component
                            : component;
                    }) }) : category;
        }), isChanged: true })); },
    _a[_Actions_1.setCoFComponents.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: state.categories.map(function (category) {
            return category.name === action.payload.categoryName
                ? __assign(__assign({}, category), { components: action.payload.components }) : category;
        }), isChanged: true })); },
    _a[_Actions_1.saveCoFResolved.toString()] = function (state) { return (__assign(__assign({}, state), { isChanged: false })); },
    _a[_Actions_1.deleteCoFCategory.toString()] = function (state, action) {
        if (!action.payload.forLoF) {
            return __assign(__assign({}, state), { categories: state.categories.filter(function (category) { return category.name !== action.payload.categoryName; }), isChanged: true });
        }
        else {
            return __assign({}, state);
        }
    },
    _a[_Actions_1.setCoFIsChanged.toString()] = function (state, action) { return (__assign(__assign({}, state), { isChanged: action.payload })); },
    _a);
exports.cofReducer = (0, toolkit_1.createReducer)(exports.initState, exports.reducer);


/***/ }),

/***/ "./reducers/LoF.reducers.ts":
/*!**********************************!*\
  !*** ./reducers/LoF.reducers.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.lofReducer = exports.reducer = exports.initState = void 0;
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var sort_1 = __webpack_require__(/*! @Utils/sort */ "./utils/sort.ts");
exports.initState = {
    componentFields: [],
    componentInspectionFields: [],
    categories: [],
    isLoadingCategories: true,
    isLoadingFields: true,
    isLoadingInspectionFields: true,
    uniqueValue: [],
    isChanged: false,
    isValid: true,
};
exports.reducer = (_a = {},
    _a[_Actions_1.getLoFConfigResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: action.payload, isLoadingCategories: false })); },
    _a[_Actions_1.getLoFConfigRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isLoadingCategories: false })); },
    _a[_Actions_1.addLoFConfig.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: __spreadArray(__spreadArray([], state.categories, true), [action.payload], false), isChanged: true })); },
    _a[_Actions_1.setLoFConfig.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: action.payload, isChanged: true })); },
    _a[_Actions_1.getLoFInspectionFields.toString()] = function (state) { return (__assign(__assign({}, state), { componentInspectionFields: [], isLoadingInspectionFields: true })); },
    _a[_Actions_1.getLoFInspectionFieldsResolved.toString()] = function (state, action) {
        var fields = action.payload;
        return __assign(__assign({}, state), { componentInspectionFields: (0, sort_1.sortFields)(fields), isLoadingInspectionFields: false });
    },
    _a[_Actions_1.getLoFInspectionFieldsRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isLoadingInspectionFields: false })); },
    _a[_Actions_1.getLoFFields.toString()] = function (state) { return (__assign(__assign({}, state), { componentFields: [], isLoadingFields: true })); },
    _a[_Actions_1.getLoFFieldsResolved.toString()] = function (state, action) {
        var fields = action.payload;
        return __assign(__assign({}, state), { componentFields: (0, sort_1.sortFields)(fields), isLoadingFields: false });
    },
    _a[_Actions_1.getLoFFieldsRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isLoadingFields: false })); },
    _a[_Actions_1.addLoFComponent.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: state.categories.map(function (category) {
            return category.name === action.payload.categoryName
                ? __assign(__assign({}, category), { components: __spreadArray(__spreadArray([], category.components, true), [
                        action.payload.component,
                    ], false) }) : category;
        }), isChanged: true })); },
    _a[_Actions_1.setLoFComponent.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: state.categories.map(function (category) {
            return category.name === action.payload.categoryName
                ? __assign(__assign({}, category), { components: category.components.map(function (component) {
                        return component.name === action.payload.componentName
                            ? action.payload.component
                            : component;
                    }) }) : category;
        }), isChanged: true })); },
    _a[_Actions_1.setLoFComponents.toString()] = function (state, action) { return (__assign(__assign({}, state), { categories: state.categories.map(function (category) {
            return category.name === action.payload.categoryName
                ? __assign(__assign({}, category), { components: action.payload.components }) : category;
        }), isChanged: true })); },
    _a[_Actions_1.saveLoFResolved.toString()] = function (state) { return (__assign(__assign({}, state), { isChanged: false })); },
    _a[_Actions_1.deleteCategory.toString()] = function (state, action) {
        if (action.payload.forLoF) {
            return __assign(__assign({}, state), { categories: state.categories.filter(function (category) { return category.name !== action.payload.categoryName; }), isChanged: true });
        }
        else {
            return __assign({}, state);
        }
    },
    _a[_Actions_1.setLofIsChanged.toString()] = function (state, action) { return (__assign(__assign({}, state), { isChanged: action.payload })); },
    _a);
exports.lofReducer = (0, toolkit_1.createReducer)(exports.initState, exports.reducer);


/***/ }),

/***/ "./reducers/Risk.reducers.ts":
/*!***********************************!*\
  !*** ./reducers/Risk.reducers.ts ***!
  \***********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.riskReducer = exports.reducer = exports.initState = void 0;
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var AM_COMMON = __importStar(__webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers"));
var Reducers_1 = __webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers");
var filterInitialState_1 = __webpack_require__(/*! ./filterInitialState */ "./reducers/filterInitialState.ts");
var riskConfig_types_1 = __webpack_require__(/*! @Types/riskConfig.types */ "./types/riskConfig.types.ts");
var InspectionStandardType_1 = __webpack_require__(/*! @Types/InspectionStandardType */ "./types/InspectionStandardType.ts");
var RiskMatrixDefaultScores_1 = __webpack_require__(/*! ./RiskMatrixDefaultScores */ "./reducers/RiskMatrixDefaultScores.ts");
var configInitState = {
    riskSetting: {
        publishState: riskConfig_types_1.ConfigPublishState.unpublished,
        inspectionStandard: InspectionStandardType_1.InspectionStandardType.PACP,
        RiskMethod: 'multiplied',
        LOFWeighting: 50,
        COFWeighting: 50,
        Grades: {
            Low: 5,
            Medium: 10,
            High: 15,
            Extreme: 20,
            Max: 25,
        },
        LastRun: '',
        lastRunCompleted: '',
        configId: '',
        assetType: '',
        name: '',
        riskType: 'linear',
        matrix: __assign({}, RiskMatrixDefaultScores_1.defaultRiskMatrix),
    },
    LOFCategories: [],
    COFCategories: [],
};
exports.initState = {
    riskConfig: configInitState,
    isLoading: false,
    tab: '',
    riskDetails: Reducers_1.paginationInitialState,
    search: '',
    startSearch: 0,
    saveRun: false,
    dropdownFilters: (0, filterInitialState_1.riskDetailsInitialState)(),
    isSetupDirty: false,
    runCompleteReload: false,
    riskConfigNameError: '',
    isCreating: false,
    isSaving: false,
    isDeleting: false,
    refreshList: false,
    isCountLoading: [],
    riskCount: {},
    simulationData: [],
    taskData: [],
    didMatrixUpdate: false,
    riskMatrix: __assign({}, RiskMatrixDefaultScores_1.defaultRiskMatrix),
    enablePreview: false,
    cancelPreview: false,
    isPreviewLoading: false,
    previewStatus: '',
    previewObj: { grades: { lofRanges: [], cofRanges: [] }, grid: [] },
    refreshMatrixGrid: false,
    isPreviewOnLoad: false,
    editedCellsList: [],
    riskType: 'linear',
    isOnlyGradesUpdated: false,
    overallRisk: {
        riskMethod: configInitState.riskSetting.RiskMethod,
        lofWeighting: configInitState.riskSetting.LOFWeighting,
        cofWeighting: configInitState.riskSetting.COFWeighting,
    },
};
var updateRiskCount = function (state, action) {
    if (action.values || state.riskCount[action.key])
        state.riskCount[action.key] = action.values;
    return state;
};
var copyRiskCount = function (state, action) {
    if (state.riskCount[action.existingKey]) {
        state.riskCount[action.newKey] = state.riskCount[action.existingKey];
        state.riskCount[action.existingKey] = undefined;
    }
    return state;
};
var updateIsCountLoading = function (state, action) {
    if (action.loading && state.isCountLoading.indexOf(action.key) === -1)
        state.isCountLoading.push(action.key);
    else if (!action.loading && state.isCountLoading.indexOf(action.key) !== -1)
        state.isCountLoading = state.isCountLoading.filter(function (value) { return value !== action.key; });
};
exports.reducer = (_a = {},
    _a[_Actions_1.getRiskConfig.toString()] = function (state) { return (__assign(__assign({}, state), { isLoading: true })); },
    _a[_Actions_1.getRiskConfigResolved.toString()] = function (state, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var tempMatrix = ((_b = (_a = action.payload.riskSetting) === null || _a === void 0 ? void 0 : _a.matrix) === null || _b === void 0 ? void 0 : _b.grades) &&
            ((_e = (_d = (_c = action.payload.riskSetting) === null || _c === void 0 ? void 0 : _c.matrix) === null || _d === void 0 ? void 0 : _d.grid) === null || _e === void 0 ? void 0 : _e.length) > 0
            ? {
                grades: (_g = (_f = action.payload.riskSetting) === null || _f === void 0 ? void 0 : _f.matrix) === null || _g === void 0 ? void 0 : _g.grades,
                grid: (_j = (_h = action.payload.riskSetting) === null || _h === void 0 ? void 0 : _h.matrix) === null || _j === void 0 ? void 0 : _j.grid,
            }
            : __assign({}, RiskMatrixDefaultScores_1.defaultRiskMatrix);
        return __assign(__assign({}, state), { riskConfig: action.payload, riskMatrix: __assign({}, tempMatrix), riskType: (_l = (_k = action.payload.riskSetting) === null || _k === void 0 ? void 0 : _k.riskType) !== null && _l !== void 0 ? _l : 'linear', dropdownFilters: (0, filterInitialState_1.riskDetailsInitialState)(), previewStatus: '', isPreviewOnLoad: false, isPreviewLoading: false, isLoading: false, cofCfgCategories: action.payload.cofCfgCategories, lofCfgCategories: action.payload.lofCfgCategories });
    },
    _a[_Actions_1.getRiskConfigRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isLoading: false })); },
    _a[_Actions_1.clearRiskConfig.toString()] = function (state) { return (__assign(__assign({}, state), { riskConfig: configInitState, riskDetails: Reducers_1.paginationInitialState, search: '', saveRun: false, dropdownFilters: (0, filterInitialState_1.riskDetailsInitialState)(), riskCount: {}, isSetupDirty: false })); },
    _a[_Actions_1.createRiskConfig.toString()] = function (state) { return (__assign(__assign({}, state), { isCreating: true })); },
    _a[_Actions_1.duplicateRiskConfig.toString()] = function (state) { return (__assign(__assign({}, state), { isCreating: true })); },
    _a[_Actions_1.changeRiskConfigPublishState.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskConfig: __assign(__assign({}, state.riskConfig), { riskSetting: __assign(__assign({}, state.riskConfig.riskSetting), { publishState: action.payload.newPublishState }) }) })); },
    _a[_Actions_1.renameRiskConfigAction.toString()] = function (state, action) { return (__assign(__assign(__assign({}, state), action.payload), { isSaving: true })); },
    _a[_Actions_1.saveRiskConfigAction.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskConfig: __assign({}, action.payload), editedCellsList: [], isSaving: true })); },
    _a[_Actions_1.setTab.toString()] = function (state, action) { return (__assign(__assign({}, state), { tab: action.payload })); },
    _a[_Actions_1.getSimulationDataResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { simulationData: action.payload })); },
    _a[_Actions_1.getTaskDataResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { taskData: action.payload })); },
    _a[_Actions_1.getRiskDetails.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.updateGet(state.riskDetails, action.payload) })); },
    _a[_Actions_1.getRiskDetailsWSReseived.toString()] = function (state, action) {
        var searchStr = state.search;
        console.log('searchStr', searchStr);
        console.log('action.payload.searchStr', action.payload.searchStr);
        if (searchStr == '') {
            console.log('empty searchStr');
            return __assign(__assign({}, state), { riskDetails: __assign(__assign({}, AM_COMMON.updateResolved(state.riskDetails, action.payload.response)), { isWaiting: false }), startSearch: false });
        }
        else {
            if (searchStr == action.payload.searchStr) {
                console.log('matching searchStr');
                return __assign(__assign({}, state), { riskDetails: __assign(__assign({}, AM_COMMON.updateResolved(state.riskDetails, action.payload.response)), { isWaiting: false }), startSearch: false });
            }
            else {
                console.log('unmatch searchStr');
                return state;
            }
        }
    },
    _a[_Actions_1.getRiskDetailsResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.updateResolved(state.riskDetails, action.payload) })); },
    _a[_Actions_1.getRiskDetailsRejected.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.updateRejected(state.riskDetails, action.payload) })); },
    _a[_Actions_1.clearRiskScanId.toString()] = function (state) { return (__assign(__assign({}, state), { riskDetails: __assign(__assign({}, state.riskDetails), { scanId: '' }) })); },
    _a[_Actions_1.changePage.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.updatePage(state.riskDetails, action.payload) })); },
    _a[_Actions_1.changeSlice.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.updateSlice(state.riskDetails, action.payload) })); },
    _a[_Actions_1.changePagination.toString()] = function (state, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var query = AM_COMMON.makePaginationQuery({
            page: (_a = action.payload) === null || _a === void 0 ? void 0 : _a.page,
            slice: (_b = action.payload) === null || _b === void 0 ? void 0 : _b.slice,
            pages: state.riskDetails.pagination.pages,
            total: state.riskDetails.pagination.total,
            subtotal: state.riskDetails.pagination.subtotal,
            search: state.riskDetails.pagination.search,
            sortKey: state.riskDetails.pagination.sortKey,
            sortDescending: state.riskDetails.pagination.sortDescending,
        });
        var pagination = __assign(__assign({}, state.riskDetails.pagination), { slice: (_d = (_c = action.payload) === null || _c === void 0 ? void 0 : _c.slice) !== null && _d !== void 0 ? _d : (_f = (_e = state.riskDetails) === null || _e === void 0 ? void 0 : _e.pagination) === null || _f === void 0 ? void 0 : _f.slice, page: (_h = (_g = action.payload) === null || _g === void 0 ? void 0 : _g.page) !== null && _h !== void 0 ? _h : (_k = (_j = state.riskDetails) === null || _j === void 0 ? void 0 : _j.pagination) === null || _k === void 0 ? void 0 : _k.page });
        return __assign(__assign({}, state), { riskDetails: __assign(__assign({}, state.riskDetails), { isWaiting: true, status: AM_COMMON.statusLoading(), pagination: pagination, query: query }) });
    },
    _a[_Actions_1.changeSearch.toString()] = function (state, action) { return (__assign(__assign({}, state), { search: action.payload, startSearch: state.startSearch + 1, riskDetails: AM_COMMON.updateSearch(state.riskDetails, action.payload) })); },
    _a[_Actions_1.setSearchStart.toString()] = function (state, action) { return (__assign(__assign({}, state), { startSearch: action.payload
            ? state.startSearch + 1
            : state.startSearch > 0
                ? state.startSearch - 1
                : 0 })); },
    _a[_Actions_1.setSearchStartSaga.toString()] = function (state, action) { return (__assign(__assign({}, state), { startSearch: action.payload ? 1 : 0 })); },
    _a[_Actions_1.changeSort.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.updateSort(state.riskDetails, action.payload) })); },
    _a[_Actions_1.clearSelected.toString()] = function (state) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.setSelected(state.riskDetails, []) })); },
    _a[_Actions_1.setSelected.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.setSelected(state.riskDetails, action.payload) })); },
    _a[_Actions_1.addSelected.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.addSelected(state.riskDetails, action.payload) })); },
    _a[_Actions_1.removeSelected.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.removeSelected(state.riskDetails, action.payload) })); },
    _a[_Actions_1.setRiskDetailsIsBusy.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.updateIsBusy(state.riskDetails, action.payload) })); },
    _a[_Actions_1.currentRow.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskDetails: AM_COMMON.setCurrentDbId(state.riskDetails, action.payload) })); },
    _a[_Actions_1.setSaveRun.toString()] = function (state, action) { return (__assign(__assign({}, state), { saveRun: action.payload })); },
    _a[_Actions_1.setRiskCalcStatus.toString()] = function (state, action) { return (__assign(__assign({}, state), { calcStatus: action.payload })); },
    _a[_Actions_1.getLog.toString()] = function (state) { return (__assign(__assign({}, state), { log: undefined, isLoading: true })); },
    _a[_Actions_1.getLogResolved.toString()] = function (state, action) {
        var _a;
        var log = action.payload;
        if (log.startTime && log.startTime != '')
            log.startTime = new Date(Date.parse(log.startTime)).toISOString();
        if (log.endTime && log.endTime != '')
            log.endTime = new Date(Date.parse(log.endTime)).toISOString();
        return __assign(__assign({}, state), { log: log, isLoading: false, riskConfig: __assign(__assign({}, state === null || state === void 0 ? void 0 : state.riskConfig), { riskSetting: __assign(__assign({}, (_a = state === null || state === void 0 ? void 0 : state.riskConfig) === null || _a === void 0 ? void 0 : _a.riskSetting), { LastRun: log.startTime, lastRunCompleted: 
                    // Update the lastRunCompleted time only if we completed the calc otherwise just keep it
                    log.calcStatus === 'risk-calc-complete'
                        ? log.startTime
                        : state.riskConfig.riskSetting.lastRunCompleted }) }) });
    },
    _a[_Actions_1.getLogRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isLoading: false })); },
    _a[_Actions_1.changeFilterSelect.toString()] = function (state, action) { return (__assign(__assign({}, state), { dropdownFilters: AM_COMMON.updateChangeFilterSelect(state.dropdownFilters, action.payload) })); },
    _a[_Actions_1.changeFiltersSelect.toString()] = function (state, action) {
        var _a;
        var columns = (_a = action.payload) !== null && _a !== void 0 ? _a : [];
        var dropdownFilters = __assign({}, state.dropdownFilters);
        dropdownFilters.filters = {}; // Cleanup the filters
        if (columns.length !== 0) {
            dropdownFilters = AM_COMMON.changeMultipleFiltersSelect(dropdownFilters, columns);
        }
        else {
            dropdownFilters.query = '';
        }
        return __assign(__assign({}, state), { dropdownFilters: dropdownFilters });
    },
    _a[_Actions_1.updateColumnFilterSelectOptions.toString()] = function (state, action) { return (__assign(__assign({}, state), { dropsownFilters: AM_COMMON.updateColumnFilterSelectOptions(state.dropdownFilters, action.payload) })); },
    _a[_Actions_1.translate.toString()] = function (state, action) { return (__assign(__assign({}, state), { dropsownFilters: AM_COMMON.updateTranslations(state.dropdownFilters, action.payload) })); },
    _a[_Actions_1.setRiskSetupDirty.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSetupDirty: action.payload, enablePreview: action.payload })); },
    _a[_Actions_1.setRunCompleteReload.toString()] = function (state, action) { return (__assign(__assign({}, state), { runCompleteReload: action.payload })); },
    _a[_Actions_1.setRefreshList.toString()] = function (state, action) { return (__assign(__assign({}, state), { refreshList: action.payload })); },
    _a[_Actions_1.setRiskConfigNameError.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskConfigNameError: action.payload })); },
    _a[_Actions_1.setRiskConfigIsCreating.toString()] = function (state, action) { return (__assign(__assign({}, state), { isCreating: action.payload })); },
    _a[_Actions_1.setRiskIsSaving.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSaving: action.payload })); },
    _a[_Actions_1.deleteRisk.toString()] = function (state) { return (__assign(__assign({}, state), { isDeleting: true })); },
    _a[_Actions_1.setRiskIsDeleting.toString()] = function (state, action) { return (__assign(__assign({}, state), { isDeleting: action.payload })); },
    _a[_Actions_1.setRiskCountIsLoading.toString()] = function (state, action) {
        return updateIsCountLoading(state, action.payload);
    },
    _a[_Actions_1.getRiskCountResolved.toString()] = function (state, action) {
        return updateRiskCount(state, action.payload);
    },
    _a[_Actions_1.renameRiskCount.toString()] = function (state, action) {
        return copyRiskCount(state, action.payload);
    },
    _a[_Actions_1.setOverallRisk.toString()] = function (state, action) { return (__assign(__assign({}, state), { overallRisk: action.payload })); },
    //===risk matrix actions====
    _a[_Actions_1.setUpdatedRanges.toString()] = function (state, action) {
        return __assign(__assign({}, state), { riskMatrix: __assign(__assign({}, state === null || state === void 0 ? void 0 : state.riskMatrix), { grades: action.payload }) });
    },
    _a[_Actions_1.setDidMatrixUpdate.toString()] = function (state, action) {
        return __assign(__assign({}, state), { didMatrixUpdate: action.payload });
    },
    _a[_Actions_1.setUpdatedScores.toString()] = function (state, action) {
        return __assign(__assign({}, state), { riskMatrix: __assign(__assign({}, state === null || state === void 0 ? void 0 : state.riskMatrix), { grid: action.payload }) });
    },
    _a[_Actions_1.setRiskType.toString()] = function (state, action) {
        var _a;
        return __assign(__assign({}, state), { riskConfig: __assign(__assign({}, state === null || state === void 0 ? void 0 : state.riskConfig), { riskSetting: __assign(__assign({}, (_a = state === null || state === void 0 ? void 0 : state.riskConfig) === null || _a === void 0 ? void 0 : _a.riskSetting), { riskType: action.payload }) }), riskType: action.payload });
    },
    _a[_Actions_1.setEnablePreview.toString()] = function (state, action) {
        return __assign(__assign({}, state), { enablePreview: action.payload });
    },
    _a[_Actions_1.setCancellPreview.toString()] = function (state, action) {
        return __assign(__assign({}, state), { cancelPreview: action.payload });
    },
    _a[_Actions_1.setIsPreviewLoading.toString()] = function (state, action) {
        return __assign(__assign({}, state), { isPreviewLoading: action.payload });
    },
    _a[_Actions_1.setIsPreviewOnLoad.toString()] = function (state, action) {
        return __assign(__assign({}, state), { isPreviewOnLoad: action.payload });
    },
    _a[_Actions_1.setMatrixPreviewStatus.toString()] = function (state, action) {
        return __assign(__assign({}, state), { previewStatus: action.payload });
    },
    _a[_Actions_1.setRiskMatrixAfterPreview.toString()] = function (state, action) {
        return __assign(__assign({}, state), { riskMatrix: action.payload });
    },
    _a[_Actions_1.setRefreshMatrixGrid.toString()] = function (state, action) {
        return __assign(__assign({}, state), { refreshMatrixGrid: action.payload });
    },
    _a[_Actions_1.setEditedCellsList.toString()] = function (state, action) {
        return __assign(__assign({}, state), { editedCellsList: __spreadArray(__spreadArray([], state.editedCellsList, true), [action.payload], false) });
    },
    _a[_Actions_1.setOnlyGradesUpdated.toString()] = function (state, action) {
        return __assign(__assign({}, state), { isOnlyGradesUpdated: action.payload });
    },
    _a[_Actions_1.clearMatrixUpdate.toString()] = function (state, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var tempMatrix = __assign({}, RiskMatrixDefaultScores_1.defaultRiskMatrix);
        if (((_b = (_a = state.riskConfig.riskSetting) === null || _a === void 0 ? void 0 : _a.matrix) === null || _b === void 0 ? void 0 : _b.grades) &&
            ((_e = (_d = (_c = state.riskConfig.riskSetting) === null || _c === void 0 ? void 0 : _c.matrix) === null || _d === void 0 ? void 0 : _d.grid) === null || _e === void 0 ? void 0 : _e.length) > 0) {
            var tempGrade = (_g = (_f = state.riskConfig.riskSetting) === null || _f === void 0 ? void 0 : _f.matrix) === null || _g === void 0 ? void 0 : _g.grades;
            if (action.payload) {
                tempGrade = RiskMatrixDefaultScores_1.defaultRiskMatrix.grades;
            }
            var tempGrid = (_j = (_h = state.riskConfig.riskSetting) === null || _h === void 0 ? void 0 : _h.matrix) === null || _j === void 0 ? void 0 : _j.grid.map(function (entry) {
                return {
                    pipeCount: 0,
                    pipeLength: 0,
                    grade: entry.grade,
                    position: entry.position,
                };
            });
            tempMatrix = {
                grades: tempGrade,
                grid: tempGrid,
            };
        }
        return __assign(__assign({}, state), { riskMatrix: __assign({}, tempMatrix), previewStatus: '', isPreviewOnLoad: false });
    },
    _a[_Actions_1.resetRiskResolved.toString()] = function (state) {
        return __assign(__assign({}, state), { riskRunning: false });
    },
    _a);
exports.riskReducer = (0, toolkit_1.createReducer)(exports.initState, exports.reducer);


/***/ }),

/***/ "./reducers/RiskMatrixDefaultScores.ts":
/*!*********************************************!*\
  !*** ./reducers/RiskMatrixDefaultScores.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultRiskMatrix = void 0;
exports.defaultRiskMatrix = {
    grades: {
        lofRanges: [2.0, 4.0, 6.0, 8.0, 10.0],
        cofRanges: [2.0, 4.0, 6.0, 8.0, 10.0],
    },
    grid: [
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'negligible',
            position: { x: 0, y: 0 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'negligible',
            position: { x: 0, y: 1 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'low',
            position: { x: 0, y: 2 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 0, y: 3 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 0, y: 4 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'negligible',
            position: { x: 1, y: 0 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'low',
            position: { x: 1, y: 1 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 1, y: 2 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 1, y: 3 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 1, y: 4 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'low',
            position: { x: 2, y: 0 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 2, y: 1 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 2, y: 2 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 2, y: 3 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'high',
            position: { x: 2, y: 4 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 3, y: 0 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 3, y: 1 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 3, y: 2 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'high',
            position: { x: 3, y: 3 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'extreme',
            position: { x: 3, y: 4 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 4, y: 0 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 4, y: 1 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'high',
            position: { x: 4, y: 2 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'extreme',
            position: { x: 4, y: 3 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'extreme',
            position: { x: 4, y: 4 },
        },
    ],
};


/***/ }),

/***/ "./reducers/asset.reducers.ts":
/*!************************************!*\
  !*** ./reducers/asset.reducers.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assetReducer = exports.reducer = exports.initState = void 0;
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var asset_actions_1 = __webpack_require__(/*! @Actions/asset.actions */ "./actions/asset.actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.initState = {
    assetFields: [],
    assetFilters: [],
    isLoading: false,
    spatialLayerList: [],
    spatialProximityAttr: [],
    customTable: [],
};
exports.reducer = (_a = {},
    _a[asset_actions_1.getAssetFields.toString()] = function (state) { return (__assign(__assign({}, state), { isLoading: true })); },
    _a[asset_actions_1.getAssetFieldsResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetFields: action.payload, isLoading: false })); },
    _a[asset_actions_1.getAssetFieldsRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isLoading: false })); },
    _a[asset_actions_1.clearAssetFields.toString()] = function (state) { return (__assign(__assign({}, state), { assetFields: [] })); },
    _a[asset_actions_1.getAssetFilterList.toString()] = function (state) { return (__assign(__assign({}, state), { isLoading: true })); },
    _a[asset_actions_1.getAssetFilterListResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { assetFilters: action.payload, isLoading: false })); },
    _a[asset_actions_1.getAssetFilterListRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isLoading: false })); },
    _a[asset_actions_1.getSpatialLayerListResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { spatialLayerList: action.payload })); },
    _a[_Actions_1.getProximityAttributeFieldsResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { spatialProximityAttr: action.payload })); },
    _a[_Actions_1.getCustomTableFieldsResolved.toString()] = function (state, action) { return (__assign(__assign({}, state), { customTable: action.payload })); },
    _a);
exports.assetReducer = (0, toolkit_1.createReducer)(exports.initState, exports.reducer);


/***/ }),

/***/ "./reducers/component.reducers.ts":
/*!****************************************!*\
  !*** ./reducers/component.reducers.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.componentReducer = exports.reducer = exports.initState = void 0;
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.initState = {
    isLoading: false,
    unique: undefined,
    precision: 0,
    range: undefined,
    unit: undefined,
};
exports.reducer = (_a = {},
    _a[_Actions_1.clearComponentMetadata.toString()] = function (state) { return (__assign(__assign({}, state), { unique: undefined, precision: 0, range: undefined, unit: undefined, currency: undefined, isLoading: false })); },
    _a[_Actions_1.getLoFComponentInspectionMetadata.toString()] = function (state) { return (__assign(__assign({}, state), { unique: undefined, precision: 0, range: undefined, unit: undefined, currency: undefined, isLoading: true })); },
    _a[_Actions_1.getLoFComponentAssetMetadata.toString()] = function (state) { return (__assign(__assign({}, state), { unique: undefined, precision: 0, range: undefined, unit: undefined, currency: undefined, isLoading: true })); },
    _a[_Actions_1.getCoFComponentAssetMetadata.toString()] = function (state) { return (__assign(__assign({}, state), { unique: undefined, precision: 0, range: undefined, unit: undefined, currency: undefined, isLoading: true })); },
    _a[_Actions_1.getLoFComponentProximityMetadata.toString()] = function (state) { return (__assign(__assign({}, state), { unique: undefined, precision: 0, range: undefined, unit: undefined, currency: undefined, isLoading: true })); },
    _a[_Actions_1.getCoFComponentProximityMetadata.toString()] = function (state) { return (__assign(__assign({}, state), { unique: undefined, precision: 0, range: undefined, unit: undefined, currency: undefined, isLoading: true })); },
    _a[_Actions_1.getLoFComponentProximityAttrMetadata.toString()] = function (state) { return (__assign(__assign({}, state), { unique: undefined, precision: 0, range: undefined, unit: undefined, currency: undefined, isLoading: true })); },
    _a[_Actions_1.getCoFComponentProximityAttrMetadata.toString()] = function (state) { return (__assign(__assign({}, state), { unique: undefined, precision: 0, range: undefined, unit: undefined, currency: undefined, isLoading: true })); },
    _a[_Actions_1.getLoFComponentCustomTableMetadata.toString()] = function (state) { return (__assign(__assign({}, state), { unique: undefined, precision: 0, range: undefined, unit: undefined, currency: undefined, isLoading: true })); },
    _a[_Actions_1.getCoFComponentCustomTableMetadata.toString()] = function (state) { return (__assign(__assign({}, state), { unique: undefined, precision: 0, range: undefined, unit: undefined, currency: undefined, isLoading: true })); },
    _a[_Actions_1.getComponentMetadataResolved.toString()] = function (state, action) {
        var payload = action.payload;
        if (action.payload.range) {
            var precision = action.payload.precision == undefined ||
                action.payload.precision == ''
                ? 0
                : action.payload.precision;
            if (action.payload.range.max) {
                payload.range.max =
                    Math.round(action.payload.range.max * Math.pow(10, precision)) / Math.pow(10, precision);
            }
            if (action.payload.range.min) {
                payload.range.min =
                    Math.round(action.payload.range.min * Math.pow(10, precision)) / Math.pow(10, precision);
            }
        }
        return __assign(__assign({}, state), { unique: payload.unique, precision: payload.precision, range: payload.range, unit: payload.unit, currency: payload.type == 'currency' ? payload.currency : undefined, isLoading: false });
    },
    _a[_Actions_1.getComponentMetadataRejected.toString()] = function (state) { return (__assign(__assign({}, state), { isLoading: false })); },
    _a);
exports.componentReducer = (0, toolkit_1.createReducer)(exports.initState, exports.reducer);


/***/ }),

/***/ "./reducers/filterInitialState.ts":
/*!****************************************!*\
  !*** ./reducers/filterInitialState.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.riskDetailsInitialState = void 0;
var riskDetailsPagination_1 = __webpack_require__(/*! ./riskDetailsPagination */ "./reducers/riskDetailsPagination.ts");
var Reducers_1 = __webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers");
var gradeFilterOptions = function () { return [
    { id: '0', caption: 'Negligible' },
    { id: '1', caption: 'Low' },
    { id: '2', caption: 'Medium' },
    { id: '3', caption: 'High' },
    { id: '4', caption: 'Extreme' },
]; };
var conditionFilterOptions = function () { return [
    { id: '0', caption: 'No' },
    { id: '1', caption: 'Yes' },
]; };
var riskDetailsInitialState = function () {
    var headers = (0, riskDetailsPagination_1.headerReactNodes)(false, false);
    var grade = headers[riskDetailsPagination_1.Column.Grade];
    var condition = headers[riskDetailsPagination_1.Column.ConditionData];
    var selects = [
        {
            column: { id: condition.key, caption: condition.cell },
            options: conditionFilterOptions(),
            dataCy: condition.key,
            filterBy: Reducers_1.filterByIdSelect,
            value: '',
            multiple: false,
        },
        {
            column: { id: grade.key, caption: grade.cell },
            options: gradeFilterOptions(),
            dataCy: grade.key,
            filterBy: Reducers_1.filterByMultipleIdSelect,
            value: [],
            multiple: true,
        },
    ];
    return {
        query: '',
        filters: {},
        selects: selects.reduce(function (d, v) {
            var _a;
            return (__assign(__assign({}, d), (_a = {}, _a[v.column.id] = v, _a)));
        }, {}),
    };
};
exports.riskDetailsInitialState = riskDetailsInitialState;


/***/ }),

/***/ "./reducers/riskDetailsPagination.ts":
/*!*******************************************!*\
  !*** ./reducers/riskDetailsPagination.ts ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.paginationDefault = exports.headerReactNodes = exports.mapRowToCells = exports.ColumnNoCDFindAsset = exports.ColumnFindAsset = exports.ColumnNoCD = exports.Column = void 0;
var Reducers_1 = __webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers");
// Columns in order displayed by table
var Column;
(function (Column) {
    Column[Column["AssetId"] = 0] = "AssetId";
    Column[Column["RiskTrend"] = 1] = "RiskTrend";
    Column[Column["CurrentRisk"] = 2] = "CurrentRisk";
    Column[Column["CurrentLOF"] = 3] = "CurrentLOF";
    Column[Column["CurrentCOF"] = 4] = "CurrentCOF";
    Column[Column["ConditionData"] = 5] = "ConditionData";
    Column[Column["Grade"] = 6] = "Grade";
})(Column = exports.Column || (exports.Column = {}));
var ColumnNoCD;
(function (ColumnNoCD) {
    ColumnNoCD[ColumnNoCD["AssetId"] = 0] = "AssetId";
    ColumnNoCD[ColumnNoCD["RiskTrend"] = 1] = "RiskTrend";
    ColumnNoCD[ColumnNoCD["CurrentRisk"] = 2] = "CurrentRisk";
    ColumnNoCD[ColumnNoCD["CurrentLOF"] = 3] = "CurrentLOF";
    ColumnNoCD[ColumnNoCD["CurrentCOF"] = 4] = "CurrentCOF";
    ColumnNoCD[ColumnNoCD["Grade"] = 5] = "Grade";
})(ColumnNoCD = exports.ColumnNoCD || (exports.ColumnNoCD = {}));
var ColumnFindAsset;
(function (ColumnFindAsset) {
    ColumnFindAsset[ColumnFindAsset["AssetId"] = 0] = "AssetId";
    ColumnFindAsset[ColumnFindAsset["RiskTrend"] = 1] = "RiskTrend";
    ColumnFindAsset[ColumnFindAsset["CurrentRisk"] = 2] = "CurrentRisk";
    ColumnFindAsset[ColumnFindAsset["CurrentLOF"] = 3] = "CurrentLOF";
    ColumnFindAsset[ColumnFindAsset["CurrentCOF"] = 4] = "CurrentCOF";
    ColumnFindAsset[ColumnFindAsset["ConditionData"] = 5] = "ConditionData";
    ColumnFindAsset[ColumnFindAsset["Grade"] = 6] = "Grade";
    ColumnFindAsset[ColumnFindAsset["Menu"] = 7] = "Menu";
})(ColumnFindAsset = exports.ColumnFindAsset || (exports.ColumnFindAsset = {}));
var ColumnNoCDFindAsset;
(function (ColumnNoCDFindAsset) {
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["AssetId"] = 0] = "AssetId";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["RiskTrend"] = 1] = "RiskTrend";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["CurrentRisk"] = 2] = "CurrentRisk";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["CurrentLOF"] = 3] = "CurrentLOF";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["CurrentCOF"] = 4] = "CurrentCOF";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["Grade"] = 5] = "Grade";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["Menu"] = 6] = "Menu";
})(ColumnNoCDFindAsset = exports.ColumnNoCDFindAsset || (exports.ColumnNoCDFindAsset = {}));
var mapRowToCells = function (row) {
    var _a, _b, _c, _d, _e, _f;
    return [
        (row === null || row === void 0 ? void 0 : row.ASSET_ID) || '',
        (row === null || row === void 0 ? void 0 : row.RISK_CHANGE) == null || (row === null || row === void 0 ? void 0 : row.RISK_CHANGE) == undefined
            ? ''
            : row === null || row === void 0 ? void 0 : row.RISK_CHANGE,
        (_a = row === null || row === void 0 ? void 0 : row.CURRENT_RISK) === null || _a === void 0 ? void 0 : _a.toString(),
        (_b = row === null || row === void 0 ? void 0 : row.CURRENT_LOF) === null || _b === void 0 ? void 0 : _b.toString(),
        (_c = row === null || row === void 0 ? void 0 : row.CURRENT_COF) === null || _c === void 0 ? void 0 : _c.toString(),
        (_e = (_d = row === null || row === void 0 ? void 0 : row.CONDITION_DATA) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : '',
        (_f = row === null || row === void 0 ? void 0 : row.GRADE) === null || _f === void 0 ? void 0 : _f.toString(),
        '',
    ];
};
exports.mapRowToCells = mapRowToCells;
var headerReactNodes = function (noConditionData, showFindAsset, t) {
    var rows = [
        {
            key: 'ASSET_ID',
            cell: t ? t('Asset ID') : 'Asset ID',
            maxWidth: '200px',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'RISK_CHANGE',
            cell: t ? t('Risk Trend') : 'Risk Trend',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'CURRENT_RISK',
            cell: t ? t('Risk Score') : 'Risk Score',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'CURRENT_LOF',
            cell: t ? t('Total LoF') : 'Total LoF',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'CURRENT_COF',
            cell: t ? t('Total CoF') : 'Total CoF',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
    ];
    if (!noConditionData) {
        rows.push({
            key: 'CONDITION_DATA',
            cell: t ? t('Condition Data') : 'Condition Data',
            width: 'auto',
            align: 'left',
            sortable: false,
            padding: '0 10px',
        });
    }
    rows.push({
        key: 'GRADE',
        cell: t ? t('Grade') : 'Grade',
        width: '150px',
        align: 'left',
        sortable: true,
        padding: '0 10px',
    });
    if (showFindAsset) {
        rows.push({
            key: 'MENU',
            cell: '',
            width: '68px',
            align: 'center',
            padding: '0 10px',
        });
    }
    return rows;
};
exports.headerReactNodes = headerReactNodes;
var paginationDefault = function () { return (__assign(__assign({}, Reducers_1.paginationInitialState), { sortKey: 'uploadDateTime', sortDescending: true })); };
exports.paginationDefault = paginationDefault;


/***/ }),

/***/ "./reducers/util.reducer.ts":
/*!**********************************!*\
  !*** ./reducers/util.reducer.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.utilReducer = void 0;
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var utils_types_1 = __webpack_require__(/*! @Types/utils.types */ "./types/utils.types.ts");
var updateRiskScore = function (state, action) {
    var rows = state.riskScoreDataGrid;
    state.riskScoreDataGrid = rows.map(function (row) {
        if (row.id == action.index)
            return __assign(__assign({}, row), { score: action.score });
        else
            return row;
    });
    return state;
};
var updateRiskMultiScoreRow = function (state, action) {
    var rows = state.riskMultiScoreEditDataGrid.length == 0
        ? state.riskMultiScoreDataGrid
        : state.riskMultiScoreEditDataGrid;
    var id = action['id'];
    state.riskMultiScoreEditDataGrid = rows.map(function (row) {
        if (row['id'] == id)
            return action;
        else
            return row;
    });
    return state;
};
var updateRiskValues = function (state, action) {
    var rows = state.riskScoreDataGrid;
    state.riskScoreDataGrid = rows.map(function (row) {
        var update = action.find(function (item) { return item.index == row.id; });
        if (update)
            return __assign(__assign({}, row), { value: update.value });
        else
            return row;
    });
    return state;
};
var updateInitialState = function (state, action) {
    state.dataGridState[action.key] = action.initialState;
    return state;
};
var reducer = (_a = {},
    _a[_Actions_1.setRiskScores.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskScores: action.payload })); },
    _a[_Actions_1.setRiskEditScores.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskEditScores: action.payload })); },
    _a[_Actions_1.setRiskUnitScores.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskUnitScores: action.payload })); },
    _a[_Actions_1.setRiskScoreTable.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskScoreTable: action.payload })); },
    _a[_Actions_1.setRiskScoreDataGrid.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskScoreDataGrid: action.payload })); },
    _a[_Actions_1.setRiskMultiScoreDataGrid.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskMultiScoreDataGrid: action.payload, riskMultiScoreEditDataGrid: [] })); },
    _a[_Actions_1.setRiskNullScore.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskNullScore: action.payload })); },
    _a[_Actions_1.setRiskStatus.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskStatus: action.payload })); },
    _a[_Actions_1.setRiskRunning.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskRunning: action.payload })); },
    _a[_Actions_1.setRiskLastRun.toString()] = function (state, action) { return (__assign(__assign({}, state), { riskLastRun: action.payload })); },
    _a[_Actions_1.updateRiskScoreDataGrid.toString()] = function (state, action) {
        return updateRiskScore(state, action.payload);
    },
    _a[_Actions_1.updateRiskMultiScoreDataGridRow.toString()] = function (state, action) {
        return updateRiskMultiScoreRow(state, action.payload);
    },
    _a[_Actions_1.updateRiskValuesDataGrid.toString()] = function (state, action) {
        return updateRiskValues(state, action.payload);
    },
    _a[_Actions_1.setDataGridState.toString()] = function (state, action) {
        return updateInitialState(state, action.payload);
    },
    _a);
exports.utilReducer = (0, toolkit_1.createReducer)((0, utils_types_1.utilStoreStateInitial)(), reducer);


/***/ }),

/***/ "./store/config.store.ts":
/*!*******************************!*\
  !*** ./store/config.store.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.routeNamespace = exports.moduleNamespace = void 0;
exports.moduleNamespace = 'appAmRisk';
exports.routeNamespace = '/risk';


/***/ }),

/***/ "./types/InspectionStandardType.ts":
/*!*****************************************!*\
  !*** ./types/InspectionStandardType.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InspectionStandardType = void 0;
var InspectionStandardType;
(function (InspectionStandardType) {
    InspectionStandardType["PACP"] = "pacp";
    InspectionStandardType["WSA"] = "wsa";
    InspectionStandardType["MACP"] = "macp";
})(InspectionStandardType = exports.InspectionStandardType || (exports.InspectionStandardType = {}));


/***/ }),

/***/ "./types/riskConfig.types.ts":
/*!***********************************!*\
  !*** ./types/riskConfig.types.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConfigPublishState = void 0;
var ConfigPublishState;
(function (ConfigPublishState) {
    ConfigPublishState["published"] = "published";
    ConfigPublishState["unpublished"] = "unpublished";
})(ConfigPublishState = exports.ConfigPublishState || (exports.ConfigPublishState = {}));


/***/ }),

/***/ "./types/utils.types.ts":
/*!******************************!*\
  !*** ./types/utils.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.utilStoreStateInitial = void 0;
var utilStoreStateInitial = function () { return ({
    riskScores: [],
    riskEditScores: [],
    riskUnitScores: undefined,
    riskScoreTable: [],
    riskScoreDataGrid: [],
    riskMultiScoreDataGrid: [],
    riskMultiScoreEditDataGrid: [],
    riskNullScore: -1,
    riskStatus: '',
    riskRunning: false,
    riskLastRun: '',
    dataGridState: {},
}); };
exports.utilStoreStateInitial = utilStoreStateInitial;


/***/ }),

/***/ "./utils/actions.ts":
/*!**************************!*\
  !*** ./utils/actions.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addRouteNamespace = exports.addNamespace = void 0;
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var addNamespace = function (action) { return config_store_1.moduleNamespace + '/' + action; };
exports.addNamespace = addNamespace;
var addRouteNamespace = function (route) {
    return config_store_1.routeNamespace + '/' + route;
};
exports.addRouteNamespace = addRouteNamespace;


/***/ }),

/***/ "./utils/sort.ts":
/*!***********************!*\
  !*** ./utils/sort.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sortFields = void 0;
var sortFields = function (fields) {
    return fields.sort(function (a, b) {
        return a.userFriendlyName < b.userFriendlyName
            ? -1
            : a.userFriendlyName > b.userFriendlyName
                ? 1
                : 0;
    });
};
exports.sortFields = sortFields;


/***/ }),

/***/ "@innovyze/lib-am-common/Reducers":
/*!***************************************************!*\
  !*** external "@innovyze/lib-am-common/Reducers" ***!
  \***************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Reducers__;

/***/ }),

/***/ "@reduxjs/toolkit":
/*!**********************************************************************************************************************************!*\
  !*** external {"commonjs":"@reduxjs/toolkit","commonjs2":"@reduxjs/toolkit","amd":"@Reduxjs/Toolkit","root":"@Reduxjs/Toolkit"} ***!
  \**********************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__;

/***/ }),

/***/ "redux":
/*!**************************************************************************************!*\
  !*** external {"commonjs":"redux","commonjs2":"redux","amd":"Redux","root":"Redux"} ***!
  \**************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_redux__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it uses a non-standard name for the exports (exports).
(() => {
var exports = __webpack_exports__;
/*!***************************!*\
  !*** ./reducers/index.ts ***!
  \***************************/

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reducerKey = exports.initialState = void 0;
var CoF_reducers_1 = __webpack_require__(/*! ./CoF.reducers */ "./reducers/CoF.reducers.ts");
var component_reducers_1 = __webpack_require__(/*! ./component.reducers */ "./reducers/component.reducers.ts");
var LoF_reducers_1 = __webpack_require__(/*! ./LoF.reducers */ "./reducers/LoF.reducers.ts");
var Risk_reducers_1 = __webpack_require__(/*! ./Risk.reducers */ "./reducers/Risk.reducers.ts");
var asset_reducers_1 = __webpack_require__(/*! ./asset.reducers */ "./reducers/asset.reducers.ts");
var redux_1 = __webpack_require__(/*! redux */ "redux");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var util_reducer_1 = __webpack_require__(/*! ./util.reducer */ "./reducers/util.reducer.ts");
var utils_types_1 = __webpack_require__(/*! @Types/utils.types */ "./types/utils.types.ts");
exports.initialState = {
    LoFConfig: LoF_reducers_1.initState,
    CoFConfig: CoF_reducers_1.initState,
    RiskStore: Risk_reducers_1.initState,
    assets: asset_reducers_1.initState,
    ComponentStore: component_reducers_1.initState,
    util: (0, utils_types_1.utilStoreStateInitial)(),
};
exports["default"] = (0, redux_1.combineReducers)({
    LoFConfig: LoF_reducers_1.lofReducer,
    CoFConfig: CoF_reducers_1.cofReducer,
    RiskStore: Risk_reducers_1.riskReducer,
    assets: asset_reducers_1.assetReducer,
    ComponentStore: component_reducers_1.componentReducer,
    util: util_reducer_1.utilReducer,
});
exports.reducerKey = config_store_1.moduleNamespace;

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=Reducers.js.map